<template>
    <v-dialog
        v-model="dialogModel"
        bottom
        width="290"
        @click:outside="cancel()"
    >
        <template v-slot:activator="{on}">
            <v-text-field
                :clearable="clearable"
                :label="label ? label : $t('msg.month')"
                outlined
                hide-details
                dense
                v-on="on"
                readonly
                :value="getLabel"
                class="month_label"
            ></v-text-field>
        </template>
        <v-card class="month__picker-wrap">
            <v-date-picker
                type="month"
                v-model="localValue"
                :locale="$store.getters.lang"
                scrollable
            ></v-date-picker>
            <div style="overflow: hidden;" class="pa-4 pt-0">
                <btns-wrap>
                    <c-btn
                        color="primary"
                        @click="cancel"
                    >{{ $t('msg.cancel') }}</c-btn>
                    <c-btn
                        color="primary"
                        @click="apply"
                    >{{ $t('msg.apply') }}</c-btn>
                </btns-wrap>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {type: String, default: null},
        clearable: {type: Boolean, default: false},
        label: {type: String, default: null}
    },
    data() {
        return {
            localValue: this.value,
            oldValue: this.value,
            dialogModel: false
        };
    },
    watch: {
        value(v) {
            this.localValue = v;
            this.oldValue = v;
        }
    },
    computed: {
        getLabel() {
            return this.cMonthFormat(this.value);
        }
    },
    methods: {
        apply() {
            this.emit();
            this.dialogModel = false;
        },
        cancel() {
            this.localValue = this.oldValue;
            this.dialogModel = false;
        },
        emit() {
            this.$emit('input', this.localValue);
        }
    }
}
</script>

<style lang="scss">
.month_label {
    .v-input__slot {
        cursor: pointer;
    }
    .v-text-field__slot {
        cursor: pointer;
    }
    input {
        cursor: pointer;
    }
}
.month__picker-wrap {
    .v-picker {
        box-shadow: none !important;
    }
    .v-date-picker-table {
        height: inherit !important;
    }
}
</style>